import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.FavoriteVacanciesContainer),
  () => import('./FavoriteVacanciesRender'),
  (container) => {
    ComponentUtil.binder(Hooks.FavoriteVacanciesContainer, container);
  },
);
